import { pack, unpack } from 'msgpackr'
import { z } from 'zod'
import { base62 } from './base62.js'

const sourceSystemSchema = z.enum(['sage100'])

const pairingCodePayloadSchema = z.object({
  companyIntegrationId: z.string(),
  ngrokAuthToken: z.string(),
  connectorSecret: z.string(),
  label: z.string(),
  sourceSystem: sourceSystemSchema,
})

export type PairingCodePayload = z.infer<typeof pairingCodePayloadSchema>

export function encodePairingCode(payload: PairingCodePayload): string {
  return base62.encode(pack(payload))
}

export function decodePairingCode(pairingCode: string): PairingCodePayload {
  const buffer = base62.decode(pairingCode)
  return pairingCodePayloadSchema.parse(unpack(buffer))
}
